const getActiveCoords = (state) => { return state.activeCoords }
const getActiveLayer = (state) => { return state.activeLayerId }
const getBounds = (state) => { return state.bounds }
const getMapMarkers = (state) => { return state.mapMarkers }
const getMarkerColor = (state) => { return state.markerStyle.iconColor }
const getMarkerIcon = (state) => { return state.markerStyle.iconImage }
const getMarkerLayer = (state) => { return state.targetMarkerLayer }
const getMarkerSize = (state) => { return state.markerStyle.iconSize }
const getZoom = (state) => { return state.zoom }

export default {
  getActiveCoords,
  getActiveLayer,
  getBounds,
  getMapMarkers,
  getMarkerColor,
  getMarkerIcon,
  getMarkerLayer,
  getMarkerSize,
  getZoom,
}
